<template>
    <app-layout>
        <template #header>
            <h2 class="title">Return Checkout</h2>
            <AppHead title="Return Checkout" />
            <flash-messages />
        </template>
        <div class="bg-white p-3">
            <div class="m-1">
                <a :href="route('mtd.return.index')"><i class="fa-solid fa-arrow-left"></i> Back to Returns</a>
            </div>
            <div class="row justify-content-center">
                <div class="col-md-auto vl-parent">
                    <LoadingOverlay v-model:active="loading" is-full-page="false" />
                    <div>
                        <p class="text-secondary font-italic">Returns must be like new condition and in orignal packaging
                        </p>
                    </div>
                    <div>
                        <p v-if="complete" class="font-weight-bold">Please ship the indicated items. Warranties and Credits
                            will be issued when items are processed.</p>
                        <p v-else class="font-weight-bold">Please select a shipping option for each return shipment</p>
                    </div>
                    <table class="w-100" style="border-collapse: collapse;">
                        <template v-for="returnShipment in returnShipments">
                            <ReturnShipment :returnShipment="returnShipment" isCheckout="true" :submitted="complete"
                                @printPackingSlip="openPrintPackingSlip" />
                            <tr>
                                <td colspan="4">
                                    <div class="pb-3"></div>
                                </td>
                            </tr>
                        </template>
                    </table>
                    <div v-if="!complete" class="mb-3 text-center">
                        <JetButton @click="submit">Complete Return <i class="ml-2 fa-solid fa-boxes-packing nav-icon"></i>
                        </JetButton>
                    </div>
                    <div v-else class="mb-3 text-center">
                        <JetButton :goesTo="route('mtd.return.index')">Finished <i
                                class="ml-2 fa-solid fa-flag-checkered nav-icon"></i>
                        </JetButton>
                    </div>
                </div>
            </div>
        </div>
    </app-layout>
    <teleport to="body">
        <PrintModal :printUrl="printUrl" @print="print" />
    </teleport>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import FlashMessages from '@/Shared/FlashMessages'
import JetButton from '@/Jetstream/Button'
import LoadingOverlay from '@/Components/General/LoadingOverlay.vue';
import toastr from 'toastr'
import PrintModal from '@/Components/Modals/PrintModal.vue';
import ReturnShipment from '@/Components/Returns/ReturnShipment.vue';

export default {
    components: {
        AppLayout,
        FlashMessages,
        JetButton,
        PrintModal,
        LoadingOverlay,
        ReturnShipment,
    },
    props: {
        returnCartShipments: Array,
    },
    data() {
        return {
            loading: false,
            returnShipments: [],
            complete: false,
            printingReturnShipmentId: null,
            printReport: '',
            printUrl: '',
        }
    },
    mounted() {
        this.returnShipments = this.returnCartShipments;
    },
    methods: {
        submit() {
            this.loading = true;
            axios.post(this.route('mtd.return.submit'), { returnShipments: this.returnShipments })
                .then((response) => {
                    if (response.data.success) {
                        this.returnShipments = response.data.returnShipments;
                        this.complete = true;
                    } else {
                        toastr.error("Unable to submit return: " + response.data.error);
                    }
                }).catch(
                    function (error) {
                        toastr.error("Unable to submit return: " + error);
                        return Promise.reject(error)
                    }
                ).finally(() => this.loading = false);
        },
        openPrintPackingSlip(returnShipmentId) {
            this.printReport = 'mtd.return.packingslip'
            this.printingReturnShipmentId = returnShipmentId
            this.openPrintDialog();
        },
        openPrintDialog() {
            this.setPrintUrl(0);
            $('#PrintModal').modal('show');
        },
        print() {
            this.setPrintUrl(1);
        },
        setPrintUrl(print) {
            this.printUrl = this.route(this.printReport, { returnShipment: this.printingReturnShipmentId, print: print });
        },
    },
}
</script>


<style>
.ShippingSelectButton>.p-button {
    width: 110px;
}

.ShippingPrintButton {
    width: 150px;
}
</style>